/**
 * Slug-aware redirect for retired pricing / cert-checkout URLs.
 * Bare `/pricing` → catalog; `/learn/:slug/certificate/checkout` → game `#pricing`.
 */
import { useParams } from "react-router-dom";
import { RedirectRoute } from "./RedirectRoute";
import { pricingLandingHref } from "@/lib/pathwayRoutes";

export function PricingLandingRedirect({ slug }: { slug?: string | null }) {
  return <RedirectRoute to={pricingLandingHref(slug)} />;
}

/** Route element: reads `:slug` from `/learn/:slug/certificate/checkout`. */
export function PathwayCertificateCheckoutRedirect() {
  const { slug } = useParams<{ slug: string }>();
  return <PricingLandingRedirect slug={slug} />;
}
